import { useEffect, useState, useCallback } from 'react'
import axios from 'axios'

export default function useMarkdownFile(url: string) {
  const [content, setContent] = useState('')
  const loadMarkdown = useCallback(async () => {
    try {
      const file = await axios.get(url)
      setContent(file.data)
    } catch (error) {
      console.error('failed to fetch markdown file', error)
    }
  }, [url])

  useEffect(() => {
    loadMarkdown()
  }, [loadMarkdown])

  return content
}
